var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tagName,
    _vm._b(
      {
        tag: "component",
        class: _vm.classes,
        attrs: { disabled: _vm.itemDisabled },
        on: { click: _vm.handleClickLink }
      },
      "component",
      _vm.tagProps,
      false
    ),
    [
      _vm.loading
        ? _c("Icon", {
            staticClass: "ivu-load-loop",
            attrs: { type: "ios-loading" }
          })
        : _vm._e(),
      _vm._v(" "),
      (_vm.icon || _vm.customIcon) && !_vm.loading
        ? _c("Icon", { attrs: { type: _vm.icon, custom: _vm.customIcon } })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSlot
        ? _c("span", { ref: "slot" }, [_vm._t("default")], 2)
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-540b1605", { render: render, staticRenderFns: staticRenderFns })
  }
}